<ion-list mode="md" lines="inset">
  <ion-item
    mode="md"
    button
    color="grayDemon"
    type="button"
    lines="inset"
    *ngFor="let item of options.array | filtro: search:'descripcion'"
    (click)="onSelect(item.descripcion)"
  >
    <ion-label mode="md" color="white">
      {{ item.descripcion }}
    </ion-label>
  </ion-item>
</ion-list>
